'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginMode = undefined;
exports.createRedirectUrl = createRedirectUrl;
exports.issueCodeAndRedirect = issueCodeAndRedirect;
exports.default = redirect;
exports.submitLogin = submitLogin;
exports.isUserAuthorize = isUserAuthorize;
exports.getAuthorizeRoute = getAuthorizeRoute;

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _config = require('./../config');

var _config2 = _interopRequireDefault(_config);

var _createLoginClient = require('./createLoginClient');

var _createLoginClient2 = _interopRequireDefault(_createLoginClient);

var _Error = require('./Error');

var _ClientError = require('./ClientError');

var _Cookie = require('./Cookie');

var _Cookie2 = _interopRequireDefault(_Cookie);

var _Router = require('./Router');

var _Subscription = require('./Subscription');

var _Logs = require('./Logs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validator = require('email-validator');

var LoginMode = exports.LoginMode = {
  ParingCode: 'PAIRING_CODE',
  Preauthorized: 'PREAUTHORIZED',
  SSO: 'SSO',
  Watermark: 'WATERMARK'
};

function addRedirectQuery(redirectUri, state, lang) {
  // Have to clear search because search will be used in place of query
  if (redirectUri.search) {
    redirectUri.search = '';
  }

  redirectUri.query.language = lang;
  redirectUri.query.state = state;

  return redirectUri;
}

function addCodeQuery(uri, code) {
  uri.query.code = code;
  return _url2.default.format(uri);
}

function createRedirectUrl(redirectUri, code, state, lang) {
  redirectUri = addRedirectQuery(redirectUri, state, lang);
  return addCodeQuery(redirectUri, code);
}

function issueCodeAndRedirect(loginClient, sessionId, auth, pushState, redirectUri, clientId, deviceId, newLocation) {
  return loginClient.oauth.issueCode({ sessionId: sessionId,
    clientId: clientId,
    redirectUri: redirectUri,
    deviceId: deviceId }, { responseContentType: 'application/json' }).then(function (result) {
    window.location.replace(addCodeQuery(newLocation, result.obj.code));
  }).catch(function (error) {
    (0, _Error.logError)(error.statusText);
    // Clear session Id if it's an issue
    if (error.obj.code === _Error.ErrorConst.InvalidValue && error.obj.field === 'sessionId') {
      document.cookie = _cookie2.default.serialize((0, _Cookie2.default)(_config2.default.envPrefix, _Cookie.loginSessionIdName, auth.realm), '', { expires: new Date(0), domain: (0, _Cookie.getCookieDomain)(), path: _Cookie.rootPath });
    }
    (0, _ClientError.logClientErrorWithLoggingService)(error, new Error().stack, 'universal-loginError', auth);
    pushState((0, _Router.getErrorRetryPath)());
  });
}

function redirect(sessionId, auth, log, appInfo, pushState, eventSelectedOption) {
  var query = _url2.default.parse(window.location.href, true).query;
  var redirectUri = _url2.default.parse(query.redirect_uri, true);
  // TODO Validate uri
  (0, _createLoginClient2.default)().then(function (loginClient) {
    var userDeviceId = (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm);
    (0, _Logs.logRedirect)(sessionId, auth, log, appInfo, loginClient, eventSelectedOption, redirectUri.href, query.client_id, userDeviceId);
    return issueCodeAndRedirect(loginClient, sessionId, auth, pushState, query.redirect_uri, query.client_id, userDeviceId, addRedirectQuery(redirectUri, query.state, auth.lang));
  }).catch(function (error) {
    (0, _ClientError.createLoginClientError)(error, new Error().stack, pushState, auth);
  });
}

function submitLogin(email, password, lang, captchaToken, editCaptchaError, editLoginError, clearInput, login, loading) {
  if (validator.validate(email) && password) {
    if (!captchaToken) {
      editCaptchaError(true);
    } else {
      loading(true);
      login(email, password, lang, captchaToken);
    }
  } else {
    clearInput();
    editLoginError(true);
  }
}

function isUserAuthorize(userInfo) {
  var value = void 0;
  var remainingMinutes = userInfo.account.subscription.remainingMinutes;
  if (userInfo.account.operatorId && userInfo.account.subscription) {
    if (userInfo.account.subscription.subscriptionType !== _Subscription.SubscriptionType.NONE && userInfo.account.subscription.subscriptionPlan !== _Subscription.SubscriptionPlan.NONE && (!remainingMinutes && remainingMinutes !== 0 || userInfo.account.subscription.remainingMinutes > 0)) {
      value = true;
    }
  }
  return value;
}

function getAuthorizeRoute(userInfo) {
  var route = void 0;

  if (userInfo.account.subscription) {
    if (userInfo.account.subscription.subscriptionType === _Subscription.SubscriptionType.GRACE_PERIOD && !userInfo.account.subscription.infinite) {
      route = _Router.RouterConst.TrialExpired;
    } else {
      route = _Router.RouterConst.AuthorizationExpired;
    }
  } else {
    route = _Router.RouterConst.Authorization;
  }
  return route;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Login.js
// module id = 73
// module chunks = 0